import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const updateCurrentUser: (
  fetchContext: FetchContext,
  accessToken?: string,
) => Promise<void> = (fetchContext, accessToken) => fetch(`${fetchContext.baseUrl}/api/me`,
  {
    method: 'PUT',
    body: JSON.stringify({}),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'update current user'));
